import VideoBanner from "./Components/VideoBanner";
import SecondSection from "./Components/SecondSection";
import ThirdSection from "./Components/ThirdSection";
import FourthSection from "./Components/FourthSection";
import FifthSection from "./Components/FifthSection";

import styles from "./styles.module.scss";

const JumboPicker = () => {
  return (
    <main className={styles.container}>
      <VideoBanner />
      <SecondSection />
      <ThirdSection />
      <FourthSection />
      <FifthSection />
    </main>
  );
};

export default JumboPicker;
